export enum SystemResultType {
    MATCH = 1,
    NOMATCH = 2,
    PARTIALMATCH = 3,
}
